import { ParceiroResponse } from "../parceiro/parceiroResponse";

export const LOGIN_TOKEN = 'LOGIN_TOKEN'
export const PARCEIRO_DATA = 'PARCEIRO_DATA'
export const SSE_VALUE = 'SSE_VALUE'  //TODO REMOVER
export const SSE_VALUEEnd = 'SSE_VALUEEnd'  //TODO REMOVER

export interface AuthenticationState {
	authState: boolean;
	parceiroState: ParceiroResponse;
	isAuthenticated: boolean;
	sseValue : number | undefined  //TODO REMOVER
	sseValueEnd : string | undefined  //TODO REMOVER
}

export interface AuthenticationAction {
	type: typeof LOGIN_TOKEN,
	payload: true
}

export interface ParceiroAction {
	type: typeof PARCEIRO_DATA,
	payload: ParceiroResponse
}

export interface SSEAction {  //TODO REMOVER
	type: typeof SSE_VALUE,
	payload: number
}

export interface SSEEndAction {  //TODO REMOVER
	type: typeof SSE_VALUEEnd,
	payload: string
}


export type AuthenticationActionTypes = AuthenticationAction | ParceiroAction 
| SSEAction | SSEEndAction;  //TODO REMOVER